<template>
  <v-layout row wrap>
    <due-detail
      v-for="(item, index) in keys" :key="`detail-item-${index}`"
      :title="item"
      :detail="details[item][0]">
    </due-detail>
  </v-layout>
</template>

<script>
  import DueDetail from './DueDetail';
  
  export default {
    components: {
      DueDetail,
    },
    props: {
      details: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      keys() {
        return Object.keys(this.details);
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/customer/DueDetails.vue